import { IoDiamondOutline } from "react-icons/io5";
import { hasSubscription } from "~/utils/user";
import { usePopup, useConversation } from '~/helpers/store';
import { useParams } from 'react-router-dom';
import { cn } from '~/utils/';

export default function Header() {
  const { conversationId } = useParams();
  const pState = usePopup((state) => state);
  const convoState = useConversation((state) => state);
  const showPricingPopup = () => {
    pState.setShowPricingPopup(true);
  }

  return (
    <header className="z-[2]">
      <div className={cn(`flex absolute items-center right-4 top-4`, 
        convoState.view === 'chat' ? 'chat-view-header' : 'pdf-view-header',
        conversationId === 'new' ? 'display-block' : ''
      )}>
        {(!hasSubscription()) && (
          <button
            className="go_pro_btn px-3 py-1.5 rounded items-center mr-2 flex"
            style={{
              background: '#fbfbfb',
              border: '1px solid gray',
              borderRadius: '25px',
              color: '#2b93e5',
            }}
            onClick={showPricingPopup}
            title="GO PRO"
            type="button"
          >
            <IoDiamondOutline></IoDiamondOutline>
            <span className="font-sm ml-2">GO PRO</span>
          </button>
        )}
      </div>
    </header>
  );
}
